import React from 'react';

// Initialisez votre contexte avec la valeur par défaut de shouldShakeButton
export const ShakeButtonContext = React.createContext({
    shouldShakeButton: false,
    setShouldShakeButton: (value: boolean) => {},
    shakeButton: () => {},
});
